import {Component} from '@angular/core';

@Component({
    selector: 'tfl-delivered-transfer-icon',
    template: require('./delivered.html')
})
export class DeliveredTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/delivered/deivered.transfer.icon.ts